import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">平台运营快讯与资源更新播报</p>

        <div className="relative pl-6 border-l-2 border-primary-200 space-y-6">
          {updatesData.map((item, idx) => (
            <div key={idx} className="relative pl-6">
              <div className="absolute left-[-31px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}